import { render, staticRenderFns } from "./RegisterSuccessPage.vue?vue&type=template&id=4a9c0722&"
import script from "./RegisterSuccessPage.vue?vue&type=script&lang=js&"
export * from "./RegisterSuccessPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSuccessPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports